import { LeadType, UserType } from '../common/enums';

export enum UserNoteType {
  Student = UserType.Student,
  Staff = UserType.Staff,
  Enrolment = LeadType.Enrolment,
  Contact = LeadType.Contact,
}

export enum UserNoteAssignee {
  Unassigned = 'UNASSIGNED',
}

export enum UserNoteCreator {
  Honeycode = 'HONEYCODE',
  CognitoWebsite = 'COGNITO_WEBSITE',
  CognitoAutomation = 'COGNITO_AUTOMATION',
}

export const UserNoteCreatorDisplayName: Record<UserNoteCreator, string> = {
  [UserNoteCreator.Honeycode]: 'Honeycode',
  [UserNoteCreator.CognitoWebsite]: 'Cognito Website',
  [UserNoteCreator.CognitoAutomation]: 'Cognito Automation',
};
